import { __assign, __extends, __rest } from "tslib";
import React, { Component } from 'react';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import styles from '../styles/styles.js';
import { currencyFormatter } from '../utils.js';
import { PnmacTable, PnmacRow, PnmacSectionListView, PnmacPageBubble, PnmacRowHeader, PnmacUIButton, PnmacSelect, PnmacTextInput, PnmacInputMask, PnmacMediaQuery, PnmacMeta, PnmacText, PnmacTitle, PnmacModal, PnmacLinearProgress, PnmacPagination, PnmacMobileDatePicker, PnmacNavigation, PnmacHtmlToNative } from 'pnmac-universal-components';
import { View, TouchableOpacity, TouchableHighlight } from 'react-native';
import moment from 'moment';
import { DateRangeIcon } from '../Icons';
import { FILTER_LOAN_ACTIVITY } from '../redux/actions/actions.js';
import Transaction from '../components/Transaction.js';
import BannerView from '../v2/BannerView';
import { textStyle } from '../v2/theme';
import withPnmacTitle from '../withPnmacTitle';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../redux/events/events";
function LinearBuffer() {
  var _a = React.useState(0),
    completed = _a[0],
    setCompleted = _a[1];
  var _b = React.useState(10),
    buffer = _b[0],
    setBuffer = _b[1];
  var progress = React.useRef(function () {});
  React.useEffect(function () {
    progress.current = function () {
      if (completed > 100) {
        setCompleted(0);
        setBuffer(10);
      } else {
        var diff = Math.random() * 10;
        var diff2 = Math.random() * 10;
        setCompleted(completed + diff);
        setBuffer(completed + diff + diff2);
      }
    };
  });
  React.useEffect(function () {
    function tick() {
      progress.current();
    }
    var timer = setInterval(tick, 500);
    return function () {
      clearInterval(timer);
    };
  }, []);
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacLinearProgress, {
    variant: "buffer",
    value: completed,
    valueBuffer: buffer
  }));
}
var styles4 = {
  container: {
    flex: 1,
    padding: 16,
    paddingTop: 30,
    backgroundColor: '#fff',
    width: '50%'
  },
  text: {
    margin: 10
  },
  head: {
    borderBottom: "1px solid #e9e9e9",
    backgroundColor: "#FFF"
  },
  heavyUnderline: {
    borderBottom: "2px solid black"
  },
  textHead: {
    margin: 10,
    fontWeight: "bold",
    backgroundColor: "#FFF",
    fontSize: 14
  },
  row: {
    flexDirection: 'row'
  },
  btn: {
    width: 58,
    height: 18,
    backgroundColor: '#78B7BB',
    borderRadius: 2
  },
  btnText: {
    textAlign: 'center',
    color: '#fff'
  }
};
function BreakDown(_a) {
  var onClose = _a.onClose,
    open = _a.open,
    selectedIndex = _a.selectedIndex,
    translations = _a.translations,
    matches = _a.matches,
    history = _a.history,
    prevPostions = _a.prevPostions,
    nextPostions = _a.nextPostions,
    layout = _a.layout;
  var selectedActivity = history[parseInt(selectedIndex)];
  var DATAEXPANDABLE = [{
    title: translations.Details,
    data: [{
      header: translations.Details
    }]
  }, /* transactionCode=1558->Adjustment/Reversal - Principal Reduction, transactionCode=1008->Adjustment/Reversal */
  (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.transactionAmount) == 0.00 && ((selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.transactionCode) == 1558 || selectedActivity.transactionCode == 1008) ? {
    title: translations.AdjustmentReversalBreakdown,
    data: [{
      header: translations.AdjustmentReversalBreakdown
    }]
  } : null, {
    title: translations.Balances,
    data: [{
      header: translations.Balances
    }]
  }].filter(function (s) {
    return s;
  });
  var col = React.useRef();
  var english = (layout === null || layout === void 0 ? void 0 : layout.language) == "en";
  //const isNextPostAvailable = parseInt(selectedIndex) + 1 < history.length;
  var parsedIndex = parseInt(selectedIndex, 10);
  var isNextPostAvailable = parsedIndex + 1 < history.length;
  return /*#__PURE__*/React.createElement(View, {
    style: layout.mobile ? {
      display: "flex"
    } : null
  }, /*#__PURE__*/React.createElement(PnmacModal, {
    open: open,
    onClose: onClose,
    "aria-label": "payments breakdown"
  }, /*#__PURE__*/React.createElement(View, {
    style: layout.mobile ? __assign(__assign({}, styles.shadowStyles), {
      alignSelf: "center",
      borderRadius: 10,
      boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
      padding: 20,
      width: matches.small ? '98%' : 500,
      backgroundColor: "#f5f5f5",
      height: matches.small ? "80%" : "initial",
      overflow: "scroll"
    }) : {
      alignSelf: "center",
      borderRadius: 10,
      boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
      padding: 20,
      width: matches.small ? '98%' : 500,
      backgroundColor: "#f5f5f5",
      height: matches.small ? "80%" : "initial"
    }
  }, /*#__PURE__*/React.createElement(PnmacTitle, {
    style: textStyle.formTitleSection
  }, translations.TransactionDetails), /*#__PURE__*/React.createElement(View, {
    style: __assign(__assign({
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    }, !matches.small ? {
      cursor: "pointer"
    } : {}), {
      marginTop: 10,
      marginBottom: 10
    })
  }, /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: function () {
      return prevPostions(parseInt(selectedIndex) - 1);
    }
  }, /*#__PURE__*/React.createElement(View, {
    id: 'btnPrevious'
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: textStyle.clickableLink
  }, translations.PreviousLinkText))), /*#__PURE__*/React.createElement(TouchableHighlight, {
    disabled: !isNextPostAvailable,
    onPress: function () {
      return isNextPostAvailable && prevPostions(parseInt(selectedIndex) + 1);
    },
    style: [!isNextPostAvailable && {
      opacity: 0.5
    }]
  }, /*#__PURE__*/React.createElement(View, {
    id: 'btnNext'
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: !isNextPostAvailable ? textStyle.disabled : textStyle.clickableLink
  }, translations.NextLinkText)))), /*#__PURE__*/React.createElement(PnmacSectionListView, {
    openDefaults: [translations.Details, translations.Balances],
    ref: col,
    data: DATAEXPANDABLE,
    collapsableSections: true,
    renderItem: function (_a, collapsed) {
      var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
      var item = _a.item,
        index = _a.index;
      if (collapsed.some(function (s) {
        return s == item.header;
      })) {
        if (item.header == translations.Details) {
          return /*#__PURE__*/React.createElement(View, {
            style: layout.mobile ? {
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              backgroundColor: "#FFF",
              overflow: "hidden"
            } : {
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              backgroundColor: "#FFF",
              overflow: "hidden"
            }
          }, /*#__PURE__*/React.createElement(View, {
            style: (_b = styles.selectionListView) === null || _b === void 0 ? void 0 : _b.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.EffectiveDate)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, moment(selectedActivity.effectiveDate).format("MM/DD/YYYY")))), ("Payment" == (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.transactionCodeDesc) || "Payment - Regular" == (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.transactionCodeDesc)) && selectedActivity.principalAmount > 0 && selectedActivity.interestAmount > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_c = styles.selectionListView) === null || _c === void 0 ? void 0 : _c.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.DueDate)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, moment(selectedActivity.dueDate).format("MM/DD/YYYY")))) : null, /*#__PURE__*/React.createElement(View, {
            style: (_d = styles.selectionListView) === null || _d === void 0 ? void 0 : _d.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.ShortDescription)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, english ? selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.transactionCodeDesc : selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.spanishTransactionCodeDesc, (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.instrumentTypeId) == 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, null), /*#__PURE__*/React.createElement(PnmacText, {
            style: {
              fontWeight: '700'
            }
          }, "by eDisbursement")) : (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.instrumentTypeId) == 2 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, null), /*#__PURE__*/React.createElement(PnmacText, {
            style: {
              fontWeight: '700'
            }
          }, "by Check")) : null))), (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.transactionAmount) == 0.00 && ((selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.transactionCode) == 1558 || selectedActivity.transactionCode == 1008) ? null : /*#__PURE__*/React.createElement(View, {
            style: __assign(__assign({}, (_e = styles.selectionListView) === null || _e === void 0 ? void 0 : _e.rowItemStyles), {
              borderBottomColor: "transparent"
            })
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.TransactionAmount)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.transactionAmount) < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.transactionAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.transactionAmount)))));
        } else if (item.header == translations.AdjustmentReversalBreakdown) {
          return /*#__PURE__*/React.createElement(View, {
            style: layout.mobile ? {
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              backgroundColor: "#FFF",
              overflow: "hidden"
            } : {
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              backgroundColor: "#FFF",
              overflow: "hidden"
            }
          }, (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.principalAmount) == 0.00 ? null : /*#__PURE__*/React.createElement(View, {
            style: (_f = styles.selectionListView) === null || _f === void 0 ? void 0 : _f.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.Principal)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.principalAmount) < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.principalAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.principalAmount)))), (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.interestAmount) == 0.00 ? null : /*#__PURE__*/React.createElement(View, {
            style: (_g = styles.selectionListView) === null || _g === void 0 ? void 0 : _g.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.Interest)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.interestAmount) < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.interestAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.interestAmount)))), (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.escrowAmount) == 0.00 ? null : /*#__PURE__*/React.createElement(View, {
            style: (_h = styles.selectionListView) === null || _h === void 0 ? void 0 : _h.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.Escrow)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.escrowAmount) < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.escrowAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.escrowAmount)))));
        } else if (item.header == translations.PaymentBreakdown) {
          return /*#__PURE__*/React.createElement(View, {
            style: layout.mobile ? {
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              backgroundColor: "#FFF",
              overflow: "hidden"
            } : {
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              backgroundColor: "#FFF",
              overflow: "hidden"
            }
          }, selectedActivity.principalAmount > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_j = styles.selectionListView) === null || _j === void 0 ? void 0 : _j.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.Principal)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.principalAmount) < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.principalAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.principalAmount)))) : null, selectedActivity.interestAmount > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_k = styles.selectionListView) === null || _k === void 0 ? void 0 : _k.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.Interest)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.interestAmount) < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.interestAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.interestAmount)))) : null, selectedActivity.escrowAmount > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_l = styles.selectionListView) === null || _l === void 0 ? void 0 : _l.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.Escrow)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.escrowAmount) < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.escrowAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.escrowAmount)))) : null, selectedActivity.payee > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_m = styles.selectionListView) === null || _m === void 0 ? void 0 : _m.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.Payee)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, selectedActivity.payee))) : null, selectedActivity.feeAndLateChargeAmount > 0 ? /*#__PURE__*/React.createElement(View, {
            style: __assign(__assign({}, (_o = styles.selectionListView) === null || _o === void 0 ? void 0 : _o.rowItemStyles), {
              borderBottomColor: "transparent"
            })
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.FeesLateCharges)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, currencyFormatter('en-US', 'currency', 'USD', selectedActivity.feeAndLateChargeAmount)))) : null, selectedActivity.creditAHInsuranceAmount > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_p = styles.selectionListView) === null || _p === void 0 ? void 0 : _p.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.CreditDisabilityInsurance)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, currencyFormatter('en-US', 'currency', 'USD', selectedActivity.creditAHInsuranceAmount)))) : null, selectedActivity.mortgageLifeInsurance > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_q = styles.selectionListView) === null || _q === void 0 ? void 0 : _q.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.MortgageLifeInsurance)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, currencyFormatter('en-US', 'currency', 'USD', selectedActivity.mortgageLifeInsurance)))) : null, selectedActivity.otherAmount > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_r = styles.selectionListView) === null || _r === void 0 ? void 0 : _r.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.Miscellaneous)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, currencyFormatter('en-US', 'currency', 'USD', selectedActivity.otherAmount)))) : null, selectedActivity.borrowerServiceChargeAmount > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_s = styles.selectionListView) === null || _s === void 0 ? void 0 : _s.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.BorrowerServiceCharge)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, currencyFormatter('en-US', 'currency', 'USD', selectedActivity.borrowerServiceChargeAmount)))) : null, selectedActivity.restrictedEscrowAmount > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_t = styles.selectionListView) === null || _t === void 0 ? void 0 : _t.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.RestrictedEscrow)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, currencyFormatter('en-US', 'currency', 'USD', selectedActivity.restrictedEscrowAmount)))) : null, selectedActivity.replacementReserveAmount > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_u = styles.selectionListView) === null || _u === void 0 ? void 0 : _u.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.ReplacementReserves)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, currencyFormatter('en-US', 'currency', 'USD', selectedActivity.replacementReserveAmount)))) : null, selectedActivity.creditBalance > 0 ? /*#__PURE__*/React.createElement(View, {
            style: (_v = styles.selectionListView) === null || _v === void 0 ? void 0 : _v.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.AppliedToCreditBalance)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, currencyFormatter('en-US', 'currency', 'USD', selectedActivity.creditBalance)))) : null);
        } else if (item.header == translations.Balances) {
          return /*#__PURE__*/React.createElement(View, {
            style: layout.mobile ? {
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              backgroundColor: "#FFF",
              overflow: "hidden"
            } : {
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              backgroundColor: "#FFF",
              overflow: "hidden"
            }
          }, /*#__PURE__*/React.createElement(View, {
            style: (_w = styles.selectionListView) === null || _w === void 0 ? void 0 : _w.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.EscrowBalance)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, currencyFormatter('en-US', 'currency', 'USD', selectedActivity.escrowBalance)))), /*#__PURE__*/React.createElement(View, {
            style: (_x = styles.selectionListView) === null || _x === void 0 ? void 0 : _x.rowItemStyles
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.SuspenseAmount)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, currencyFormatter('en-US', 'currency', 'USD', selectedActivity.suspenseBalanceAmount)))), /*#__PURE__*/React.createElement(View, {
            style: __assign(__assign({}, (_y = styles.selectionListView) === null || _y === void 0 ? void 0 : _y.rowItemStyles), {
              borderBottomColor: "transparent"
            })
          }, /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, translations.PrincipalBalanceColumn)), /*#__PURE__*/React.createElement(View, {
            style: styles.selectionListView.fiftyWidth
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.formBody
          }, (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.principalBalance) < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.principalBalance)), ")") : currencyFormatter('en-US', 'currency', 'USD', selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.principalBalance)))));
        }
      } else {
        return /*#__PURE__*/React.createElement(View, null);
      }
    },
    renderSectionHeader: function (_a) {
      var _b, _c;
      var title = _a.section.title;
      var open = ((_b = col === null || col === void 0 ? void 0 : col.current) === null || _b === void 0 ? void 0 : _b.state.collapsed.indexOf(title)) > -1;
      return /*#__PURE__*/React.createElement(PnmacRowHeader, {
        rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
        rowHeaderContainerStyles: layout.mobile ? __assign(__assign({}, styles.rowHeaderContainerStyles), {
          marginBottom: open ? 0 : 10,
          borderBottomWidth: open ? 1 : 0,
          borderBottomColor: "#EFEFEF",
          borderBottomLeftRadius: open ? 0 : 10,
          borderBottomRightRadius: open ? 0 : 10
        }) : {
          borderBottom: open ? "1px solid #e9e9e9" : "none",
          borderBottomLeftRadius: open ? 0 : 10,
          borderBottomRightRadius: open ? 0 : 10
        },
        onClickExpand: function () {
          return col.current.collapseItem(title);
        },
        item: /*#__PURE__*/React.createElement(PnmacText, {
          id: title,
          style: textStyle.formTitleSection
        }, title),
        isExpand: ((_c = col === null || col === void 0 ? void 0 : col.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1
      });
    }
  }), /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      marginTop: 20
    }
  }, /*#__PURE__*/React.createElement(PnmacUIButton, {
    idTag1: 'btnClose',
    style: {
      width: '40%'
    },
    mode: "outlined",
    onPress: function () {
      return onClose();
    }
  }, translations.CloseButtonText)))));
}
var LoanActivity = /** @class */function (_super) {
  __extends(LoanActivity, _super);
  function LoanActivity(props) {
    var _this = this;
    var _a, _b;
    _this = _super.call(this, props) || this;
    _this.setSort = function (data) {
      var direction = _this.state.sortidrection == "dsc" ? "asc" : "dsc";
      _this.setState({
        sort: data,
        sortidrection: direction
      });
    };
    _this.fetchAndGeneratePdf = function () {
      var layout = _this.props.layout;
      fetch('api/documents/get_loan_activity_docs', {
        body: JSON.stringify(layout.currentLoanActivity),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': "Bearer ".concat(layout.token)
        }
      }).then(function (response) {
        return response.blob();
      }).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/pdf'
        });
        var downloadUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = downloadUrl;
        a.download = "LoanActivity.pdf";
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
      });
    };
    _this.expRef = /*#__PURE__*/React.createRef();
    _this.expRefList = /*#__PURE__*/React.createRef();
    _this.state = {
      breakDownOpen: false,
      selectedIndex: 0,
      page: 0,
      toDate: null,
      fromDate: null,
      activityType: "All",
      loading: false,
      sort: "NoSort",
      sortidrection: "dsc",
      startingDate: moment().subtract(35, 'year').format("MM/DD/YYYY"),
      toDateOpen: false,
      fromDateOpen: false,
      loaded: false,
      dateType: 'effectiveDate',
      dateTypeValues: {
        effectiveDate: {
          text: (_a = _this.props.translations) === null || _a === void 0 ? void 0 : _a.EffectiveDate,
          value: 'effectiveDate'
        },
        transcationDate: {
          text: (_b = _this.props.translations) === null || _b === void 0 ? void 0 : _b.DropDownTransactionDate,
          value: 'transactionDate'
        }
      }
    };
    return _this;
  }
  LoanActivity.prototype.componentDidUpdate = function (prevsProps) {
    if (prevsProps.translations.EffectiveDate != this.props.translations.EffectiveDate && prevsProps.translations.DropDownTransactionDate != this.props.translations.DropDownTransactionDate) {
      this.setState({
        dateTypeValues: {
          effectiveDate: {
            text: this.props.translations.EffectiveDate,
            value: 'effectiveDate'
          },
          transcationDate: {
            text: this.props.translations.DropDownTransactionDate,
            value: 'transactionDate'
          }
        }
      });
    }
  };
  LoanActivity.prototype.runFilteredHistroy = function () {
    var _this = this;
    this.setState({
      loading: true
    });
    var _a = this.props.layout,
      selectedLoanNumber = _a.selectedLoanNumber,
      mobile = _a.mobile;
    var _b = this.state,
      fromDate = _b.fromDate,
      toDate = _b.toDate,
      activityType = _b.activityType,
      startingDate = _b.startingDate;
    if (parseInt(selectedLoanNumber) > 0) {
      var route = "/api/loan/get_loan_activity_filtered";
      var data = {
        "transactionFilter": activityType == "All" ? null : activityType,
        "loanId": selectedLoanNumber,
        "fromDate": fromDate || startingDate,
        "toDate": toDate || moment().format("MM/DD/YYYY")
      };
      fetch("".concat(route), {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(this.props.layout.token)
        },
        body: JSON.stringify(data)
      }).then(function (data) {
        return data.json();
      }).then(function (res) {
        if (res) {
          _this.setState({
            loading: false
          }, function () {
            return _this.props.dispatch({
              type: FILTER_LOAN_ACTIVITY,
              loanActivity: res
            });
          });
        } else {
          _this.setState({
            loading: false
          });
        }
      }).catch(function (err) {
        return console.log(err);
      });
    }
  };
  LoanActivity.prototype.render = function () {
    var _this = this;
    var _a, _b, _c, _d;
    var _e = this.props,
      translations = _e.translations,
      layout = _e.layout,
      rest = __rest(_e, ["translations", "layout"]);
    var _f = this.state,
      toDateOpen = _f.toDateOpen,
      fromDateOpen = _f.fromDateOpen,
      loaded = _f.loaded,
      dateTypeValues = _f.dateTypeValues;
    var english = (layout === null || layout === void 0 ? void 0 : layout.language) == "en";
    var DATAEXPANDABLE = [{
      title: translations.PastPaymentsBreakdown,
      data: [{
        header: translations.PastPaymentsBreakdown
      }]
    }];
    var DATAEXPANDABLELIST = [{
      title: translations.AllTransactions,
      data: [{
        header: translations.AllTransactions
      }]
    }];
    var lastPaymentBreakdown = (_a = layout === null || layout === void 0 ? void 0 : layout.currentLoanActivity) === null || _a === void 0 ? void 0 : _a.lastPaymentBreakdown;
    var loan = (_b = layout === null || layout === void 0 ? void 0 : layout.currentLoanActivity) === null || _b === void 0 ? void 0 : _b.loan;
    var tableHeadMobile = [translations.Elements, translations.LastMonth, translations.Year];
    var tableHead = [translations.PaymentElements, translations.PaidLastMonth, translations.PaidYearToDate];
    var tableData = [[translations.Principal, currencyFormatter('en-US', 'currency', 'USD', lastPaymentBreakdown === null || lastPaymentBreakdown === void 0 ? void 0 : lastPaymentBreakdown.monthlyPaymentAmountPrincipal), currencyFormatter('en-US', 'currency', 'USD', loan === null || loan === void 0 ? void 0 : loan.yearToDatePrincipalPaidAmount)], [translations.Interest, currencyFormatter('en-US', 'currency', 'USD', lastPaymentBreakdown === null || lastPaymentBreakdown === void 0 ? void 0 : lastPaymentBreakdown.monthlyPaymentAmountInterest), currencyFormatter('en-US', 'currency', 'USD', loan === null || loan === void 0 ? void 0 : loan.yearToDateTotalInterestPaidAmount)], [translations.EscrowTaxInsurance, currencyFormatter('en-US', 'currency', 'USD', lastPaymentBreakdown === null || lastPaymentBreakdown === void 0 ? void 0 : lastPaymentBreakdown.monthlyPaymentAmountEscrow), currencyFormatter('en-US', 'currency', 'USD', loan === null || loan === void 0 ? void 0 : loan.yearToDateEscrowPaid)], [translations.Fees, currencyFormatter('en-US', 'currency', 'USD', lastPaymentBreakdown === null || lastPaymentBreakdown === void 0 ? void 0 : lastPaymentBreakdown.monthlyFeeAmount), currencyFormatter('en-US', 'currency', 'USD', loan === null || loan === void 0 ? void 0 : loan.yearToDateFeesPaid)], [translations.CreditBalance, currencyFormatter('en-US', 'currency', 'USD', lastPaymentBreakdown === null || lastPaymentBreakdown === void 0 ? void 0 : lastPaymentBreakdown.monthlySuspenseAmount), currencyFormatter('en-US', 'currency', 'USD', loan === null || loan === void 0 ? void 0 : loan.yearToDateSuspenseBalance)], [translations.Total, currencyFormatter('en-US', 'currency', 'USD', lastPaymentBreakdown === null || lastPaymentBreakdown === void 0 ? void 0 : lastPaymentBreakdown.monthlyPaymentAmount), currencyFormatter('en-US', 'currency', 'USD', loan === null || loan === void 0 ? void 0 : loan.yearToDateTotalPaid)]];
    var escrowSlashBalance = translations.Escrow + "/\n" + translations.balance;
    var suspenseSlashBalance = translations.SuspenseAmount + "/\n" + translations.balance;
    var principalSlashBalance = translations.PrincipalColumn + "/\n" + translations.balance;
    var history = ((_c = layout.currentLoanActivity) === null || _c === void 0 ? void 0 : _c.history) || [];
    if (this.state.sort != "NoSort" && history.length > 0) {
      if (this.state.sortidrection == "asc") {
        history.sort(function (a, b) {
          if (_this.state.sort === dateTypeValues.effectiveDate.value || _this.state.sort === dateTypeValues.transcationDate.value) {
            return new Date(a[_this.state.sort]) - new Date(b[_this.state.sort]);
          }
          return a[_this.state.sort] - b[_this.state.sort];
        });
      } else {
        if (this.state.sort === dateTypeValues.effectiveDate.value || this.state.sort === dateTypeValues.transcationDate.value) {
          history.sort(function (a, b) {
            return new Date(b[_this.state.sort]) - new Date(a[_this.state.sort]);
          });
        } else {
          history.sort(function (a, b) {
            return b[_this.state.sort] - a[_this.state.sort];
          });
        }
      }
    }
    var tableHeadListHeloc = function (matches) {
      return [/*#__PURE__*/React.createElement(View, {
        style: {
          paddingStart: 8,
          flexDirection: 'row'
        },
        accessibilityLabel: "Effective Date"
      }, /*#__PURE__*/React.createElement(PnmacSelect, {
        accessibilityLabel: "Effective Date",
        idTag2: 'dropDownDate',
        style: {
          viewContainer: {
            flex: 1,
            height: 25
          },
          pickerStyle: {
            paddingRight: 0
          }
        },
        Icon: null,
        onValueChange: function (value) {
          //Prevent selecting the placeholder text.
          if (value !== 'Select an item...') {
            _this.setState({
              dateType: value
            });
          } else {
            _this.setState({
              dateType: _this.state.dateType
            });
          }
          //On selecting any date type it will sort list to most recent to oldest.
          _this.setState({
            sortidrection: 'asc'
          }, function () {
            _this.setSort(value);
          });
        },
        value: _this.state.dateType,
        items: [{
          label: dateTypeValues.effectiveDate.text,
          value: dateTypeValues.effectiveDate.value
        }, {
          label: dateTypeValues.transcationDate.text,
          value: dateTypeValues.transcationDate.value
        }]
      })), /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, translations.ShortDescription)), /*#__PURE__*/React.createElement(View, {
        style: __assign(__assign({
          padding: 10
        }, !matches.small ? {
          cursor: "pointer"
        } : {}), {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }),
        onClick: function () {
          return _this.setSort("transactionAmount");
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, translations.TransactionAmountColumn), _this.state.sortidrection == "asc" && _this.state.sort == "transactionAmount" ? /*#__PURE__*/React.createElement("img", {
        alt: "Sort by ascending order icon",
        style: {
          transform: "rotate(180deg)",
          marginLeft: 5,
          height: 8,
          width: "auto"
        },
        src: require("../assets/downarrow.png")
      }) : /*#__PURE__*/React.createElement("img", {
        alt: "Sort by descending order icon",
        style: {
          marginLeft: 5,
          height: 8,
          width: "auto"
        },
        src: require("../assets/downarrow.png")
      })), /*#__PURE__*/React.createElement(View, {
        style: __assign(__assign({
          padding: 10
        }, !matches.small ? {
          cursor: "pointer"
        } : {}), {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }),
        onClick: function () {
          return _this.setSort("principalAmount");
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, principalSlashBalance), _this.state.sortidrection == "asc" && _this.state.sort == "principalAmount" ? /*#__PURE__*/React.createElement("img", {
        alt: "Sort by ascending order icon",
        style: {
          transform: "rotate(180deg)",
          marginLeft: 5,
          height: 8,
          width: "auto"
        },
        src: require("../assets/downarrow.png")
      }) : /*#__PURE__*/React.createElement("img", {
        alt: "Sort by descending order icon",
        style: {
          marginLeft: 5,
          height: 8,
          width: "auto"
        },
        src: require("../assets/downarrow.png")
      })), /*#__PURE__*/React.createElement(View, {
        style: __assign(__assign({
          padding: 10
        }, !matches.small ? {
          cursor: "pointer"
        } : {}), {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }),
        onClick: function () {
          return _this.setSort("interestAmount");
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, translations.Interest), _this.state.sortidrection == "asc" && _this.state.sort == "interestAmount" ? /*#__PURE__*/React.createElement("img", {
        alt: "Sort by ascending order icon",
        style: {
          transform: "rotate(180deg)",
          marginLeft: 5,
          height: 8,
          width: "auto"
        },
        src: require("../assets/downarrow.png")
      }) : /*#__PURE__*/React.createElement("img", {
        alt: "Sort by descending order icon",
        style: {
          marginLeft: 5,
          height: 8,
          width: "auto"
        },
        src: require("../assets/downarrow.png")
      })), /*#__PURE__*/React.createElement(View, {
        style: __assign(__assign({
          padding: 10
        }, !matches.small ? {
          cursor: "pointer"
        } : {}), {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }),
        onClick: function () {
          return _this.setSort("escrowAmount");
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, escrowSlashBalance), _this.state.sortidrection == "asc" && _this.state.sort == "escrowAmount" ? /*#__PURE__*/React.createElement("img", {
        alt: "Sort by ascending order icon",
        style: {
          transform: "rotate(180deg)",
          marginLeft: 5,
          height: 8,
          width: "auto"
        },
        src: require("../assets/downarrow.png")
      }) : /*#__PURE__*/React.createElement("img", {
        alt: "Sort by descending order icon",
        style: {
          marginLeft: 5,
          height: 8,
          width: "auto"
        },
        src: require("../assets/downarrow.png")
      })), /*#__PURE__*/React.createElement(View, {
        style: __assign(__assign({
          padding: 10
        }, !matches.small ? {
          cursor: "pointer"
        } : {}), {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }),
        onClick: function () {
          return _this.setSort("suspenseAmount");
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, suspenseSlashBalance), _this.state.sortidrection == "asc" && _this.state.sort == "suspenseAmount" ? /*#__PURE__*/React.createElement("img", {
        alt: "Sort by ascending order icon",
        style: {
          transform: "rotate(180deg)",
          marginLeft: 5,
          height: 8,
          width: "auto"
        },
        src: require("../assets/downarrow.png")
      }) : /*#__PURE__*/React.createElement("img", {
        alt: "Sort by descending order icon",
        style: {
          marginLeft: 5,
          height: 8,
          width: "auto"
        },
        src: require("../assets/downarrow.png")
      }))];
    };
    var transactionCodes = ((layout === null || layout === void 0 ? void 0 : layout.transactionTypes) || []).map(function (s) {
      var _a;
      return {
        label: english ? s.transactionTypeDiscription : s.spanishTransactionTypeDiscription,
        value: (_a = s.filter) === null || _a === void 0 ? void 0 : _a.join(",")
      };
    }) || [];
    var transactCodes = ((_d = [{
      label: 'All',
      value: "All"
    }]) === null || _d === void 0 ? void 0 : _d.concat(transactionCodes)) || [{
      label: 'All',
      value: "All"
    }];
    var tableDataListHeloc = function (matches) {
      return history.slice(_this.state.page * 10, _this.state.page * 10 + 10).map(function (s, i) {
        return [/*#__PURE__*/React.createElement(View, {
          id: "selectedindex".concat(i),
          style: __assign(__assign({
            paddingLeft: 20,
            overflowWrap: "break-word",
            overflow: "auto",
            whiteSpace: "pre-line"
          }, !matches.small ? {
            cursor: "pointer"
          } : {}), {
            color: "#003087",
            fontSize: 12
          }),
          onClick: function () {
            return _this.setState({
              breakDownOpen: true,
              selectedIndex: history.findIndex(function (e) {
                return e == s;
              })
            });
          }
        }, /*#__PURE__*/React.createElement(PnmacText, null, moment(_this.state.dateType === dateTypeValues.effectiveDate.value ? s.effectiveDate : s.transactionDate).format("MM/DD/YYYY"))), english ? s === null || s === void 0 ? void 0 : s.transactionCodeDesc : s === null || s === void 0 ? void 0 : s.spanishTransactionCodeDesc, (s === null || s === void 0 ? void 0 : s.transactionAmount) < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s === null || s === void 0 ? void 0 : s.transactionAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', s === null || s === void 0 ? void 0 : s.transactionAmount), /*#__PURE__*/React.createElement(View, {
          style: {
            padding: 5
          }
        }, /*#__PURE__*/React.createElement(PnmacText, {
          style: {
            color: "#5C5C5C"
          }
        }, s.principalAmount < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.principalAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', s.principalAmount)), /*#__PURE__*/React.createElement(PnmacText, {
          style: {
            color: "#5C5C5C"
          }
        }, s.principalBalance < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.principalBalance)), ")") : currencyFormatter('en-US', 'currency', 'USD', s.principalBalance))), s.interestAmount < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.interestAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', s.interestAmount), /*#__PURE__*/React.createElement(View, {
          style: {
            padding: 5
          }
        }, /*#__PURE__*/React.createElement(PnmacText, {
          style: {
            color: "#5C5C5C"
          }
        }, s.escrowAmount < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.escrowAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', s.escrowAmount)), /*#__PURE__*/React.createElement(PnmacText, {
          style: {
            color: "#5C5C5C"
          }
        }, s.escrowBalance < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.escrowBalance)), ")") : currencyFormatter('en-US', 'currency', 'USD', s.escrowBalance))), /*#__PURE__*/React.createElement(View, {
          style: {
            padding: 5
          }
        }, /*#__PURE__*/React.createElement(PnmacText, {
          style: {
            color: "#5C5C5C"
          }
        }, s.suspenseAmount < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.suspenseAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', s.suspenseAmount)), /*#__PURE__*/React.createElement(PnmacText, {
          style: {
            color: "#5C5C5C"
          }
        }, s.suspenseBalanceAmount < 0 ? "(".concat(currencyFormatter('en-US', 'currency', 'USD', Math.abs(s.suspenseBalanceAmount)), ")") : currencyFormatter('en-US', 'currency', 'USD', s.suspenseBalanceAmount)))];
      });
    };
    var lookBack = history.slice(this.state.page * 10, this.state.page * 10 + 10);
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      onRefresh: function () {
        _this.props.authenticate(false);
      },
      refreshing: layout.reloadingData,
      queries: {
        xSmall: "(max-width: 300px)",
        small: "(max-width: 599px)",
        iPad: "(max-width: 1023px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a, _b, _c, _d, _e;
      return /*#__PURE__*/React.createElement(View, {
        style: {
          paddingHorizontal: 10,
          paddingBottom: 10
        }
      }, /*#__PURE__*/React.createElement(BreakDown, {
        matches: matches,
        history: history,
        selectedIndex: _this.state.selectedIndex,
        layout: _this.props.layout,
        prevPostions: function (valu) {
          if (valu >= 0) {
            _this.setState({
              selectedIndex: valu
            });
          }
        },
        nextPostions: function (valu) {
          if (valu <= (history === null || history === void 0 ? void 0 : history.length) - 1) {
            _this.setState({
              selectedIndex: valu
            });
          }
        },
        translations: translations,
        open: _this.state.breakDownOpen,
        onClose: function () {
          return _this.setState({
            breakDownOpen: false
          });
        }
      }), /*#__PURE__*/React.createElement(PnmacMeta, {
        title: !matches.small ? translations.loanActivity : translations.activity
      }), /*#__PURE__*/React.createElement(View, {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          marginBottom: 10,
          backgroundColor: '#fff',
          padding: 10,
          borderRadius: 10
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextTitle
      }, translations.Loan, " ", translations.Number)), /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, !layout.selectedLoanNumber ? /*#__PURE__*/React.createElement(PnmacLinearProgress, null) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, layout.selectedLoanNumber))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          width: "100%",
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextTitle
      }, translations.Property, " ", translations.Address)), /*#__PURE__*/React.createElement(View, {
        style: {
          flex: matches.xSmall ? 2 : 1
        }
      }, !((_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.propertyAddressLine1) ? /*#__PURE__*/React.createElement(PnmacLinearProgress, null) : /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, (_b = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _b === void 0 ? void 0 : _b.propertyAddressLine1)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, (_c = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _c === void 0 ? void 0 : _c.propertyLocality, " ", (_d = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _d === void 0 ? void 0 : _d.propertyRegion, ", ", (_e = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _e === void 0 ? void 0 : _e.propertyPostalCode)))))), /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function () {
          return PnmacNavigation(__assign({
            action: {
              pathname: "/StatementsAndDocuments"
            },
            layout: layout
          }, rest));
        }
      }, /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({
        layout: layout
      }, rest, {
        size: 14,
        value: translations.AdditionalInformation
      })))), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacSectionListView, {
        openDefaults: [translations.AllTransactions],
        idTag1: 'allTransactionBreakDown',
        ref: _this.expRefList,
        data: DATAEXPANDABLELIST,
        collapsableSections: true,
        renderItem: function (_a, collapsed) {
          var _b;
          var item = _a.item;
          if (matches.small || collapsed.some(function (s) {
            return s == item.header;
          })) {
            return /*#__PURE__*/React.createElement(View, {
              style: {
                borderBottomRightRadius: 10,
                borderBottomLeftRadius: 10
              }
            }, !matches.small && /*#__PURE__*/React.createElement(View, {
              style: {
                justifyContent: "center",
                backgroundColor: "#FFF",
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                padding: 10,
                paddingBottom: matches.large || matches.iPad ? 20 : "initial",
                borderBottom: "1px solid #e9e9e9"
              }
            }, /*#__PURE__*/React.createElement(View, {
              style: {
                display: "flex",
                flexDirection: matches.large || matches.iPad ? "column" : "row",
                flex: 1,
                justifyContent: "center"
              }
            }, /*#__PURE__*/React.createElement(View, {
              style: {
                display: "flex",
                flexDirection: matches.small ? "column" : "row",
                justifyContent: "center",
                alignItems: "center"
              }
            }, /*#__PURE__*/React.createElement(View, null, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
              for: "lblTxtFromDate"
            }, /*#__PURE__*/React.createElement(PnmacText, {
              style: textStyle.formBody
            }, "Dates")) : /*#__PURE__*/React.createElement(PnmacText, {
              style: textStyle.formBody
            }, "Dates")), /*#__PURE__*/React.createElement(View, {
              style: {
                marginLeft: 10,
                marginRight: 20
              }
            }, /*#__PURE__*/React.createElement(PnmacTextInput, {
              id: "lblTxtFromDate",
              idTag1: 'txtFromDate',
              noUnderline: true,
              style: {
                height: 35,
                marginBottom: 10,
                marginLeft: 10
              },
              value: _this.state.fromDate || "mm/dd/yyyy",
              onChangeText: function (fromDate) {
                return _this.setState({
                  fromDate: fromDate
                });
              },
              render: function (props) {
                var style = props.style,
                  translationText = props.translationText,
                  multiline = props.multiline,
                  toggleTheme = props.toggleTheme,
                  underlineColorAndroid = props.underlineColorAndroid,
                  editable = props.editable,
                  selectionColor = props.selectionColor,
                  toggleLanguage = props.toggleLanguage,
                  placeholderTextColor = props.placeholderTextColor,
                  onChangeText = props.onChangeText,
                  testID = props.testID,
                  rest = __rest(props, ["style", "translationText", "multiline", "toggleTheme", "underlineColorAndroid", "editable", "selectionColor", "toggleLanguage", "placeholderTextColor", "onChangeText", "testID"]);
                var st = style.reduce(function (a, i) {
                  return __assign(__assign({}, a), i);
                });
                st.paddingTop = 0;
                st.backgroundColor = 'unset';
                st.border = 'unset';
                st.color = "#003087";
                return /*#__PURE__*/React.createElement(View, {
                  style: {
                    flexDirection: 'row',
                    alignItems: 'center'
                  }
                }, /*#__PURE__*/React.createElement(PnmacInputMask, __assign({
                  affineFormats: [],
                  customNotations: [],
                  affinityCalculationStrategy: 'WHOLE_STRING',
                  style: __assign(__assign({}, st), {
                    width: 90
                  }),
                  value: rest.value,
                  mask: "99/99/9999"
                }, rest, {
                  onChange: function (e) {
                    onChangeText(e.target.value);
                  }
                })), /*#__PURE__*/React.createElement(DateRangeIcon, {
                  onClick: function () {
                    return _this.setState({
                      fromDateOpen: true
                    });
                  }
                }));
              }
            })), /*#__PURE__*/React.createElement(View, null, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
              for: "lblTxtToDate"
            }, /*#__PURE__*/React.createElement(PnmacText, {
              style: textStyle.formBody
            }, "to")) : /*#__PURE__*/React.createElement(PnmacText, {
              style: textStyle.formBody
            }, "to")), /*#__PURE__*/React.createElement(View, {
              style: {
                marginLeft: 15
              }
            }, /*#__PURE__*/React.createElement(PnmacTextInput, {
              id: "lblTxtToDate",
              idTag1: 'txtToDate',
              noUnderline: true,
              style: {
                height: 35,
                marginBottom: 7,
                marginLeft: 10
              },
              value: _this.state.toDate || "mm/dd/yyyy",
              onChangeText: function (toDate) {
                return _this.setState({
                  toDate: toDate
                });
              },
              render: function (props) {
                var style = props.style,
                  translationText = props.translationText,
                  multiline = props.multiline,
                  toggleTheme = props.toggleTheme,
                  underlineColorAndroid = props.underlineColorAndroid,
                  editable = props.editable,
                  selectionColor = props.selectionColor,
                  toggleLanguage = props.toggleLanguage,
                  placeholderTextColor = props.placeholderTextColor,
                  onChangeText = props.onChangeText,
                  testID = props.testID,
                  rest = __rest(props, ["style", "translationText", "multiline", "toggleTheme", "underlineColorAndroid", "editable", "selectionColor", "toggleLanguage", "placeholderTextColor", "onChangeText", "testID"]);
                var st = style.reduce(function (a, i) {
                  return __assign(__assign({}, a), i);
                });
                st.paddingTop = 0;
                st.backgroundColor = 'unset';
                st.border = 'unset';
                st.borderBottomColor = 'transparent';
                return /*#__PURE__*/React.createElement(View, {
                  style: {
                    flexDirection: 'row',
                    alignItems: 'center'
                  }
                }, /*#__PURE__*/React.createElement(PnmacInputMask, __assign({
                  affineFormats: [],
                  customNotations: [],
                  affinityCalculationStrategy: 'WHOLE_STRING',
                  style: __assign(__assign({}, st), {
                    width: 90
                  }),
                  value: rest.value,
                  mask: "99/99/9999"
                }, rest, {
                  onChange: function (e) {
                    onChangeText(e.target.value);
                  }
                })), /*#__PURE__*/React.createElement(DateRangeIcon, {
                  onClick: function () {
                    return _this.setState({
                      toDateOpen: true
                    });
                  }
                }));
              }
            }))), /*#__PURE__*/React.createElement(View, {
              style: {
                display: "flex",
                flexDirection: matches.small ? "column" : "row",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: matches.iPad ? 20 : 0
              }
            }, /*#__PURE__*/React.createElement(View, {
              style: {
                marginTop: 7,
                marginLeft: 10,
                marginRight: 10,
                marginBottom: matches.small ? 10 : 0
              }
            }, /*#__PURE__*/React.createElement(PnmacText, {
              style: textStyle.formBody
            }, "Transaction Type")), /*#__PURE__*/React.createElement(View, {
              style: {
                marginBottom: matches.small ? 20 : 0
              }
            }, /*#__PURE__*/React.createElement(PnmacSelect, {
              accessibilityLabel: "Transaction type",
              idTag2: 'dropDownActivityType',
              style: {
                marginLeft: 10,
                width: matches.small ? "50%" : "100%",
                height: 20
              },
              onValueChange: function (value) {
                return _this.setState({
                  activityType: value
                });
              },
              value: _this.state.activityType,
              items: transactCodes
            })), /*#__PURE__*/React.createElement(View, {
              style: {
                display: "flex",
                flexDirection: "row",
                marginLeft: matches.small ? 0 : 20
              }
            }, /*#__PURE__*/React.createElement(View, {
              style: {
                marginBottom: matches.small ? 20 : 0,
                marginRight: 15
              }
            }, /*#__PURE__*/React.createElement(PnmacUIButton, {
              idTag1: 'btnFilter',
              mode: "contained",
              style: {
                minWidth: "40%"
              },
              onClick: function () {
                _this.setState({
                  page: 0
                }, function () {
                  return _this.runFilteredHistroy();
                });
              }
            }, "Filter")), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
              idTag1: 'btnDownload',
              mode: "contained",
              style: {
                minWidth: "40%"
              },
              disabled: !layout.currentLoanActivity || layout.currentLoanActivity.length == 0,
              onClick: function () {
                _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Loan Activity Download Button clicked Web", 0);
                _this.fetchAndGeneratePdf();
              }
            }, "Download")))))), tableDataListHeloc(matches).length > 0 && !_this.state.loading ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacTable, {
              style: {}
            }, !matches.small ? /*#__PURE__*/React.createElement(PnmacRow, {
              flexArr: [1, 1, 1, 1, 1, 1, 1, 1],
              data: tableHeadListHeloc(matches),
              textStyle: __assign(__assign({}, textStyle.formTitleSection), {
                paddingTop: 10,
                paddingBottom: 10
              }),
              style: __assign(__assign({}, styles.shadowStyles), {
                backgroundColor: "#FFF"
              })
            }) : /*#__PURE__*/React.createElement(View, null), tableDataListHeloc(matches).map(function (rowData, index) {
              return matches.small ? /*#__PURE__*/React.createElement(React.Fragment, null, collapsed.indexOf(translations.AllTransactions) > -1 && /*#__PURE__*/React.createElement(Transaction, {
                escrowFlag: layout.currentLoan.escrowFlag,
                topLeftRadius: 0,
                topRightRadius: 0,
                locale: layout === null || layout === void 0 ? void 0 : layout.language,
                key: index,
                transaction: lookBack[index],
                onTransactionPress: function (transaction) {
                  return _this.setState({
                    breakDownOpen: true,
                    selectedIndex: history.findIndex(function (e) {
                      return e == transaction;
                    })
                  });
                },
                translations: translations,
                secondaryInfoEllipsizeMode: 'tail'
              })) : /*#__PURE__*/React.createElement(PnmacRow, {
                flexArr: [1, 1, 1, 1, 1, 1, 1, 1],
                data: rowData,
                textStyle: __assign(__assign({}, textStyle.formBody), {
                  padding: matches.small ? 5 : 10
                }),
                style: {
                  backgroundColor: "#FFF"
                },
                key: "".concat(rowData[0] + index)
              });
            }), layout.mobile && collapsed.indexOf(translations.AllTransactions) > -1 ? /*#__PURE__*/React.createElement(View, {
              style: {
                backgroundColor: "white",
                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10,
                marginBottom: 20,
                justifyContent: "center"
              }
            }, /*#__PURE__*/React.createElement(PnmacPagination, {
              onChange: function (e, p) {
                return _this.setState({
                  page: p - 1
                });
              },
              page: _this.state.page + 1,
              count: (_b = history === null || history === void 0 ? void 0 : history.length) !== null && _b !== void 0 ? _b : 0
            })) : /*#__PURE__*/React.createElement(View, null)), layout.mobile ? null : /*#__PURE__*/React.createElement(View, {
              style: layout.mobile ? {
                backgroundColor: "#FFF",
                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10,
                marginBottom: 10,
                display: "flex",
                justifyContent: "center"
              } : {
                backgroundColor: "#FFF",
                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10,
                marginBottom: 10,
                display: "flex",
                paddingBottom: 20,
                justifyContent: "center"
              }
            }, /*#__PURE__*/React.createElement(PnmacPagination, {
              styles: {
                ul: {
                  justifyContent: 'center'
                }
              },
              style: {
                marginTop: 20,
                width: "100%"
              },
              onChange: function (e, p) {
                return _this.setState({
                  page: p - 1
                });
              },
              page: _this.state.page + 1,
              count: (history === null || history === void 0 ? void 0 : history.length) % 10 == 0 ? parseInt(history.length / 10) : parseInt(history.length / 10) + 1,
              variant: "outlined",
              shape: "rounded",
              color: "primary",
              size: matches.small ? 'small' : 'medium'
            }))) : _this.state.loading ? /*#__PURE__*/React.createElement(LinearBuffer, null) : /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, null, translations.NoTransactionsReturned)));
          } else {
            return null;
          }
        },
        renderSectionHeader: function (_a) {
          var _b, _c;
          var title = _a.section.title;
          var open = ((_c = (_b = _this.expRefList) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
          return matches.small ? /*#__PURE__*/React.createElement(PnmacRowHeader, {
            "aria-label": "All transactions",
            accessibilityLabel: "All transactions",
            rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
            rowHeaderContainerStyles: layout.mobile ? {
              marginBottom: 0,
              borderBottomWidth: open ? 1 : 0,
              borderBottomColor: "#EFEFEF",
              borderBottomLeftRadius: open ? 0 : 10,
              borderBottomRightRadius: open ? 0 : 10
            } : {
              borderBottom: open ? "1px solid #e9e9e9" : "none",
              borderBottomLeftRadius: open ? 0 : 10,
              borderBottomRightRadius: open ? 0 : 10
            },
            onClickExpand: function () {
              var _a, _b;
              var collapse = (_b = (_a = _this.expRefList) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.collapseItem(title);
            },
            item: /*#__PURE__*/React.createElement(PnmacText, {
              id: title,
              style: textStyle.formTitleSection
            }, title),
            isExpand: open
          }) : /*#__PURE__*/React.createElement(PnmacRowHeader, {
            "aria-label": "All transactions",
            accessibilityLabel: "All transactions",
            rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
            rowHeaderContainerStyles: {
              borderBottom: open ? "1px solid #e9e9e9" : "none",
              borderBottomLeftRadius: open ? 0 : 10,
              borderBottomRightRadius: open ? 0 : 10
            },
            onClickExpand: function () {
              var _a;
              return (_a = _this.expRefList) === null || _a === void 0 ? void 0 : _a.current.collapseItem(title);
            },
            item: /*#__PURE__*/React.createElement(PnmacText, {
              id: title,
              style: textStyle.formTitleSection
            }, title),
            isExpand: open
          });
        }
      })), !matches.small && /*#__PURE__*/React.createElement(PnmacMobileDatePicker, {
        openTo: "year",
        views: ["year", "month", "date"],
        disableFuture: true,
        open: fromDateOpen,
        inputFormat: "DD/MM/YYYY",
        value: new Date(_this.state.fromDate),
        renderInput: function () {
          return null;
        },
        maxDate: moment().add('days', 2),
        onClose: function () {
          return _this.setState({
            fromDateOpen: false
          });
        },
        onChange: function (date) {
          return _this.setState({
            fromDate: moment(date).format("MM/DD/YYYY")
          });
        },
        animateYearScrolling: true
      }), !matches.small && /*#__PURE__*/React.createElement(PnmacMobileDatePicker, {
        openTo: "year",
        views: ["year", "month", "date"],
        disableFuture: true,
        open: toDateOpen,
        inputFormat: "DD/MM/YYYY",
        value: new Date(_this.state.toDate),
        renderInput: function () {
          return null;
        },
        maxDate: moment().add('days', 2),
        onClose: function () {
          return _this.setState({
            toDateOpen: false
          });
        },
        onChange: function (date) {
          return _this.setState({
            toDate: moment(date).format("MM/DD/YYYY")
          });
        },
        animateYearScrolling: true
      })));
    });
  };
  return LoanActivity;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(withPnmacTitle(LoanActivity, function (props) {
  return props.translations.loanActivity;
}));